module.exports = __webpack_public_path__ + "static/media/blog.a84a63f0.svg";